import React from 'react'
import ReactDOM from 'react-dom'

export type PluginOptions = {
  ruleSpecs?: string[]
  axeConfig?: {
    disableOtherRules: boolean
  }
  axeContext?: {
    include: string[][]
  }
  disable?: boolean
}

export const onInitialClientRender = async (_: undefined, options: PluginOptions = {}): Promise<void> => {
  const { ruleSpecs, axeConfig = {}, axeContext } = options
  if (options.disable) return

  if (process.env.NODE_ENV === 'development') {
    const { default: axeCore } = await import('axe-core')
    const { default: reactAxe } = await import('react-axe')
    const axeRules = ruleSpecs
      ? {
          rules: axeCore.getRules(ruleSpecs).map((rule) => ({
            id: rule.ruleId,
            enabled: true,
          })),
        }
      : {}

    const axeOptions = {
      ...axeRules,
      ...axeConfig,
    }

    reactAxe(React, ReactDOM, 1000, axeOptions, axeContext)
  }
}
